import Vue from 'vue';
import Vuex from 'vuex';
import createAppointmentsModule from '@/store/modules/appointments';
import createTaskModule from '@/store/modules/tasks';
import createAuthModule from '@/store/modules/auth';
import createNotificationsModule from '@/store/modules/notifications';
import createPatientModule from '@/store/modules/patient';
import createUserModule from '@/store/modules/user';
import createEmployeeModule from '@/store/modules/employee';
import createWhatsAppNotificationModule from '@/store/modules/whatsAppNotifications';
import createOnBoarding from '@/store/modules/onBoarding';
import createMobilePopup from '@/store/modules/mobilePopup';
import createScheduleModule from '@/store/modules/schedule';
import createServerMessagesModule from '@/store/modules/serverMessages';
import createPayrollModule from '@/store/modules/payroll';
import createCrmFiltersModule from '@/store/modules/crmFilters';
import createPatientFiltersModule from '@/store/modules/patientFilters';
import createCashboxFiltersModule from '@/store/modules/cashboxFilters';
import createRouterModule from '@/store/modules/router';

const strict = import.meta.env.PROD;

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    appointments: createAppointmentsModule(),
    auth: createAuthModule(),
    notifications: createNotificationsModule(),
    patient: createPatientModule(),
    user: createUserModule(),
    tasks: createTaskModule(),
    employee: createEmployeeModule(),
    mobilePopup: createMobilePopup(),
    whatsAppNotification: createWhatsAppNotificationModule(),
    onBoarding: createOnBoarding(),
    schedule: createScheduleModule(),
    serverMessages: createServerMessagesModule(),
    payroll: createPayrollModule(),
    crmFilters: createCrmFiltersModule(),
    patientFilters: createPatientFiltersModule(),
    cashboxFilters: createCashboxFiltersModule(),
    router: createRouterModule(),
  },
  strict,
});
